/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Engagement_UntilInputs */

const fr_membership_engagement_until = /** @type {(inputs: Membership_Engagement_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jusqu'au ${i?.date}`)
};

/**

* @param {Membership_Engagement_UntilInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_engagement_until = /** @type {((inputs: Membership_Engagement_UntilInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Engagement_UntilInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_engagement_until(inputs)
});